module.exports = __webpack_public_path__ + "img/mood.18abdd3a.svg";